// eslint-disable-next-line import/prefer-default-export
import { CONFIGURATION } from '@/constants/configuration';

export const AUTHENTICATION_OBJECT_TYPES = {
  USER_PASSWORD: 'userPassword',
  AWS: 'awsAuth',
  GCP: 'gcpAuth',
  AZURE: 'azureAuth',
};

export const AUTHENTICATION_TO_PROVIDER = {
  [CONFIGURATION.SOURCE_TYPE.aws]: AUTHENTICATION_OBJECT_TYPES.AWS,
  [CONFIGURATION.SOURCE_TYPE.azure]: AUTHENTICATION_OBJECT_TYPES.AZURE,
  [CONFIGURATION.SOURCE_TYPE.gcp]: AUTHENTICATION_OBJECT_TYPES.GCP,
};
export const MANUAL_CONFIGURATION_SECRET_TEXT_PLACEHOLDER = 'MANUAL_CONFIGURATION_SECRET_TEXT_PLACEHOLDER';
